export default function () {
  const { $algolia } = useNuxtApp()

  // === ALGOLIA === //
  const getAlgoliaQueryInfo = () => {
    if (!$algolia) return {}
    const { indexName, queryID } = $algolia.searchContexts.catalog.state.value
    return {
      ...(indexName && { index: indexName }),
      ...(queryID && { queryID }),
    }
  }

  // Note: We need to do this because back end does not give us ObjectID
  // but it is lame and we need to find a better way eventually.
  const getAlgoliaObjectId = async ({ productLineSlug, skuSlug, fitmentData }: any) => {
    // We must have at least a one of these to even do the search
    if (!productLineSlug && !skuSlug) return null

    let fitmentSlugs
    // Convert fitmentData to the slugified versions
    if (fitmentData) {
      fitmentSlugs = {
        year: fitmentData.year,
        ...(fitmentData.makeName && {
          makeSlug: slugify(fitmentData.makeName),
        }),
        ...(fitmentData.modelName && {
          modelSlug: slugify(fitmentData.modelName),
        }),
        ...(fitmentData.bedName && {
          bedSlug: slugify(fitmentData.bedName),
        }),
        ...(fitmentData.bodyName && {
          bodySlug: slugify(fitmentData.bodyName),
        }),
        ...(fitmentData.engineName && {
          engineSlug: slugify(fitmentData.engineName),
        }),
      }
    }

    // Start fresh on filters
    $algolia.searchContexts.productsObjectId.clearFilters(null)
    // Filter by fitment
    const fitmentFilters = useFitmentFilters()
    // If fitmentSlugs is empty fitmentFilters will fetch them from the store
    fitmentFilters.update($algolia.searchContexts.productsObjectId, fitmentSlugs)

    // Filter by the product
    if (productLineSlug) $algolia.searchContexts.productsObjectId.addFilters('productLineSlug', productLineSlug)

    // We need to also lookup by SKU
    if (skuSlug) $algolia.searchContexts.productsObjectId.addFilters('skuSlug', skuSlug)

    // Get he results
    const { results } = await $algolia.searchContexts.productsObjectId._search()
    if (results && results.length > 0) return results[0].objectID

    return null
  }

  const slugify = (string: string) => {
    return string.replace(/["' ]/g, '-').replace('--', '-').toLowerCase()
  }

  return {
    getAlgoliaQueryInfo,
    getAlgoliaObjectId,
  }
}
